let observer;

// Build observer
let callback = (elements, observer) => {
  var delay = 0;

  elements.forEach((elem) => {
    const animation = elem.target.dataset.animation ?? "fadeUp";

    if (elem.isIntersecting) {
      setTimeout(function () {
        // Add animation classes
        elem.target.classList.add(...animation.split(" "), "animated");
      }, delay);

      // Delay multiple intersections at once
      delay += 200;
      observer.unobserve(elem.target);
    }
  });
};

// Show when 48px from bottom
let options = {
  root: null,
  rootMargin: "0px 48px",
  threshold: 0,
};

observer = new IntersectionObserver(callback, options);

// Look for all animate classes
const animateOnScroll = document.querySelectorAll(".animate").forEach((el) => {
  if (el) {
    observer.observe(el);
  }
});

export { animateOnScroll };
